import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from './i18n';
import { EmailValidatorDirective } from './field-validators/email-validator';
import { OwnershipValidatorDirective } from './field-validators/ownership-validator';

@NgModule({
  declarations: [EmailValidatorDirective, OwnershipValidatorDirective],
  exports: [EmailValidatorDirective, OwnershipValidatorDirective],
  imports: [CommonModule, I18nModule]
})
export class CoreModule {}
